import { TagsService } from "../client"

/* ENDPOINTS */
export const getTags = (skip: number) => {
  return {
    queryFn: () => TagsService.readTagsPub({ skip: skip }),

    queryKey: ["tags", skip],
  }
}
